import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  style: {
    color: 'red',
    float: 'left'
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_ImgUpload = _resolveComponent("ImgUpload");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createBlock(_component_el_form, {
    rules: _ctx.data.rules,
    model: _ctx.data,
    class: "base_info",
    "label-width": "110px",
    "label-position": "left"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "SPU:",
          required: "",
          class: "el-form-diy"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            disabled: _ctx.data.isDisabled,
            modelValue: _ctx.data.createSpuInfo.spu[0].spu,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.data.createSpuInfo.spu[0].spu = $event),
            onInput: _cache[1] || (_cache[1] = $event => _ctx.spuinput(_ctx.data.createSpuInfo.spu[0].spu, 'spu', 'spu')),
            maxlength: "80",
            class: "input-w"
          }, null, 8, ["disabled", "modelValue"]), _ctx.data.spuIsSure ? (_openBlock(), _createElementBlock("span", _hoisted_1, " spu由-、.、数字、字母组成，开始、结束必须数字或字母 ")) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "产品标题:"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _ctx.data.createSpuInfo.spu_params[0].title,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.data.createSpuInfo.spu_params[0].title = $event),
            class: "input-w"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "品名:",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _ctx.data.createSpuInfo.spu_params[0].name,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.data.createSpuInfo.spu_params[0].name = $event),
            maxlength: "200",
            class: "input-w"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "产品副标题:"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _ctx.data.createSpuInfo.spu_params[0].s_title,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.data.createSpuInfo.spu_params[0].s_title = $event),
            class: "input-w"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "产品分类:",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_cascader, {
            disabled: _ctx.data.isDisabled,
            modelValue: _ctx.data.createSpuInfo.spu[0].category_id,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.data.createSpuInfo.spu[0].category_id = $event),
            "show-all-levels": "",
            ref: "getDom",
            onChange: _cache[6] || (_cache[6] = $event => _ctx.selectProdcut($event, _ctx.data.options)),
            options: _ctx.data.options,
            props: _ctx.data.props,
            style: {
              "width": "410px"
            }
          }, null, 8, ["disabled", "modelValue", "options", "props"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "OPD团队"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            disabled: _ctx.data.isDisabled,
            modelValue: _ctx.data.createSpuInfo.spu[0].opd_team_id,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.data.createSpuInfo.spu[0].opd_team_id = $event),
            filterable: "",
            placeholder: "请选择OPD团队",
            style: {
              "width": "410px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.opdList, (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: index,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["disabled", "modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "品牌:"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            disabled: _ctx.data.isDisabled,
            modelValue: _ctx.data.createSpuInfo.spu[0].brand_id,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.data.createSpuInfo.spu[0].brand_id = $event),
            filterable: "",
            placeholder: "请选择品牌",
            style: {
              "width": "410px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.brandList, (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: index,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["disabled", "modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "所属系列:"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            disabled: _ctx.data.isDisabled,
            modelValue: _ctx.data.createSpuInfo.spu_params[0].series,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _ctx.data.createSpuInfo.spu_params[0].series = $event),
            maxlength: "100",
            class: "input-w"
          }, null, 8, ["disabled", "modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _ctx.data.optionlevel == 3 ? (_openBlock(), _createBlock(_component_el_row, {
      key: 0,
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "产品单位:"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _ctx.data.createSpuInfo.spu[0].unit,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _ctx.data.createSpuInfo.spu[0].unit = $event),
            style: {
              "width": "70%"
            },
            disabled: _ctx.data.is_temp == 0
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.utillist, (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                label: item.unit_name,
                value: item.id,
                key: index
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "disabled"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "税收分类编码:"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            disabled: true,
            modelValue: _ctx.data.createSpuInfo.spu[0].tax_category_code,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _ctx.data.createSpuInfo.spu[0].tax_category_code = $event),
            class: "input-w"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 18
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "规格参数"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _ctx.data.createSpuInfo.spu_params[0].spec,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _ctx.data.createSpuInfo.spu_params[0].spec = $event),
            maxlength: "500",
            type: "textarea",
            rows: 5
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "主图:"
        }, {
          default: _withCtx(() => [_createVNode(_component_ImgUpload, {
            queryPara: _ctx.data.mainImgPara,
            "onUpdate:queryPara": _cache[13] || (_cache[13] = $event => _ctx.data.mainImgPara = $event),
            getimglist: _ctx.data.mainImgParaUrls,
            "onUpdate:getimglist": _cache[14] || (_cache[14] = $event => _ctx.data.mainImgParaUrls = $event),
            onTransmitImgParameter: _ctx.transmitImgParameter,
            onRemoveImgParameter: _ctx.removeImgParameter
          }, null, 8, ["queryPara", "getimglist", "onTransmitImgParameter", "onRemoveImgParameter"]), _cache[19] || (_cache[19] = _createElementVNode("div", {
            class: "el-upload__tip f_12"
          }, "图片尺寸800*800，大小不超过1M", -1))]),
          _: 1,
          __: [19]
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "封面图:"
        }, {
          default: _withCtx(() => [_createVNode(_component_ImgUpload, {
            queryPara: _ctx.data.coverImgPara,
            "onUpdate:queryPara": _cache[15] || (_cache[15] = $event => _ctx.data.coverImgPara = $event),
            getimglist: _ctx.data.coverImgParaUrls,
            "onUpdate:getimglist": _cache[16] || (_cache[16] = $event => _ctx.data.coverImgParaUrls = $event),
            onTransmitImgParameter: _ctx.transmitImgParameter,
            onRemoveImgParameter: _ctx.removeImgParameter
          }, null, 8, ["queryPara", "getimglist", "onTransmitImgParameter", "onRemoveImgParameter"]), _cache[20] || (_cache[20] = _createElementVNode("div", {
            class: "el-upload__tip f_12"
          }, "图片尺寸800*800，大小不超过1M", -1))]),
          _: 1,
          __: [20]
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      gutter: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "画册图："
        }, {
          default: _withCtx(() => [_createVNode(_component_ImgUpload, {
            queryPara: _ctx.data.albumImgPara,
            "onUpdate:queryPara": _cache[17] || (_cache[17] = $event => _ctx.data.albumImgPara = $event),
            getimglist: _ctx.data.albumImgParaUrls,
            "onUpdate:getimglist": _cache[18] || (_cache[18] = $event => _ctx.data.albumImgParaUrls = $event),
            onTransmitImgParameter: _ctx.transmitImgParameter,
            onRemoveImgParameter: _ctx.removeImgParameter
          }, null, 8, ["queryPara", "getimglist", "onTransmitImgParameter", "onRemoveImgParameter"]), _cache[21] || (_cache[21] = _createElementVNode("div", {
            class: "el-upload__tip f_12"
          }, " 最多可上传6张，图片尺寸800*800，大小不超过1M ", -1))]),
          _: 1,
          __: [21]
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["rules", "model"]);
}